import { useEffect, useState } from 'react'
import axios from 'axios'
import { useDataContext } from "../Context/dataContext";

function useFetchData(accessToken) {
  const { url } = useDataContext();
  const [user, setUser] = useState(null);
  const [movements, setMovements] = useState([]);
  const [directory, setDirectory] = useState([]);
  const [referralInfo, setReferralInfo] = useState([]);
  const [referralBonus, setReferralBonus] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!accessToken) return;

    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        // Obtener datos del usuario
        const response = await axios.get(
          `${url}/Auth/findByToken/${accessToken}`,
          {
            headers: { Authorization: `Bearer ${accessToken}` },
          }
        );
        setUser(response.data);

        
        // Obtener directorio del usuario
        const responseDirectory = await axios.get(
          `${url}/AccBsUser/user/${response.data.use_id}`,
          {
            headers: { Authorization: `Bearer ${accessToken}` },
          }
        );
        setDirectory(responseDirectory.data);

        // Obtener información adicional si es necesario
        const responseReferral = await axios.get(
          `${url}/Users/referredBy/${response.data.use_referrerCode}`,
          {
            headers: { Authorization: `Bearer ${accessToken}` },
          }
        );
        setReferralInfo(responseReferral.data);
        
        const responseReferralBonus = await axios.get(
          `${url}/ReferralBonus/referrer/${response.data.use_id}`,
          {
            headers: { Authorization: `Bearer ${accessToken}` },
          }
        );
        setReferralBonus(responseReferralBonus.data);
        
        // Obtener movimientos del usuario
        const responseMovements = await axios.get(
          `${url}/Movements/user/${response.data.use_id}`,
          {
            headers: { Authorization: `Bearer ${accessToken}` },
          }
        );
        setMovements(responseMovements.data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [accessToken, url]);

  return { user, movements, referralBonus, directory, referralInfo, loading, error };
}

export { useFetchData };